export function formatNumberWithCommas(number) {
  if (typeof number !== "number") return "";

  return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}

export function formatNumberWithPointsAndComma(number) {
  if (typeof number !== "number") return "";

  return number
    .toFixed(2)
    .replace(".", ",")
    .replace(/\B(?=(\d{3})+(?!\d))/g, ".");
}

export const calcularTotal = (cantidad, precio, bonificacion) => {
  const cantidadNum = Number(cantidad) || 0;
  const precioNum = Number(precio) || 0;
  const bonificacionNum = Number(bonificacion) || 0;

  const total = cantidadNum * precioNum - bonificacionNum;
  const formatearTotal = { number: total, value: formatNumberWithPointsAndComma(total) };

  return formatearTotal;
};

export const isFieldRequired = (servicioId, proveedor) => {
  // se valida el servicio ofrecido y excluye a algunos proveedores
  if ([4, 6, 8].includes(servicioId) && proveedor && proveedor.value && [710, 29, 3560, 4844].includes(proveedor.value)) {
    return false;
  }
  if ([4, 6, 8].includes(servicioId)) {
    return true;
  }
  return false;
};

// export const formatNumberWithCommas = (value) => {
//   if (!value) return "";
//   return value.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
// };

// export const removeCommas = (value) => {
//   return value.replace(/,/g, "");
// };
